export interface Actor {
  id: string;
  name: string;
  avatar: string;
  image: string;
  birthday: string;
  birthPlace: string;
  height: string;
  bio: string;
  works: string[];
  roles: { dramaId: string; role: string; desc: string }[];
}

export const actors: Actor[] = [
  {
    id: "actor-lin-qingwan",
    name: "林清婉",
    avatar:
      "https://readdy.ai/api/search-image?query=Elegant%20portrait%20of%20a%20gentle%20Chinese%20actress%20with%20soft%20warm%20smile%2C%20natural%20makeup%2C%20cream%20blouse%2C%20warm%20beige%20studio%20background%2C%20soft%20editorial%20lighting%2C%20professional%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-lin-qingwan-portrait&orientation=squarish",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20warm%20editorial%20portrait%20of%20a%20gentle%20Chinese%20actress%20sitting%20by%20a%20sunlit%20window%2C%20cream%20knitwear%2C%20soft%20warm%20beige%20background%2C%20calm%20expressive%20mood%2C%20cinematic%20soft%20light%2C%20wide%20composition%2C%20high%20detail&width=1200&height=800&seq=actor-lin-qingwan-wide&orientation=landscape",
    birthday: "1993-05-12",
    birthPlace: "浙江杭州",
    height: "168cm",
    bio: "林清婉毕业于国内知名艺术院校表演系，以细腻克制、富有层次的表演风格著称。她擅长塑造温柔而坚韧的女性角色，多次凭借家庭情感题材作品获得观众口碑与行业奖项提名，被观众亲切地称为“最有温度的演员”。",
    works: ["kind-sister-in-law", "city-lights"],
    roles: [
      { dramaId: "kind-sister-in-law", role: "苏婉", desc: "家中的“嫂子”，在变故后独自撑起整个家，用善良化解身边所有偏见与冷漠。" },
      { dramaId: "city-lights", role: "沈微", desc: "创意公司里最年轻的合伙人，外表强势内心柔软，在竞争与友情之间寻找平衡。" },
    ],
  },
  {
    id: "actor-chen-zimo",
    name: "陈子墨",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20handsome%20young%20Chinese%20actor%20with%20calm%20confident%20expression%2C%20dark%20hair%2C%20simple%20charcoal%20shirt%2C%20warm%20neutral%20studio%20background%2C%20soft%20editorial%20lighting%2C%20professional%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-chen-zimo-portrait&orientation=squarish",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20warm%20portrait%20of%20a%20young%20Chinese%20actor%20in%20a%20thoughtful%20pose%20against%20a%20soft%20warm%20background%2C%20muted%20earth%20tones%2C%20moody%20expressive%20lighting%2C%20wide%20composition%2C%20high%20detail&width=1200&height=800&seq=actor-chen-zimo-wide&orientation=landscape",
    birthday: "1991-09-27",
    birthPlace: "山东青岛",
    height: "183cm",
    bio: "陈子墨是近年来备受关注的实力派男演员，戏路宽广，既能驾驭冷峻的悬疑角色，也能诠释带有成长弧光的少年形象。他注重角色的内在逻辑，常常为角色进行大量前期准备，表演真实而有张力。",
    works: ["kind-sister-in-law", "silent-witness", "long-night-clear", "fog-city-mystery"],
    roles: [
      { dramaId: "kind-sister-in-law", role: "顾言", desc: "苏婉的小叔子，最初对嫂子充满戒备，在朝夕相处中逐渐被善意打动。" },
      { dramaId: "silent-witness", role: "林队", desc: "执着追查悬案的刑警，面对沉默的证人始终不肯放弃真相。" },
    ],
  },
  {
    id: "actor-zhou-yaqin",
    name: "周雅琴",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20confident%20mature%20Chinese%20actress%20with%20short%20elegant%20hair%2C%20warm%20assured%20expression%2C%20beige%20knit%20sweater%2C%20warm%20cream%20background%2C%20soft%20editorial%20lighting%2C%20professional%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-zhou-yaqin-portrait&orientation=squarish",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20warm%20portrait%20of%20a%20mature%20elegant%20Chinese%20actress%20in%20a%20cozy%20sunlit%20study%2C%20warm%20beige%20and%20clay%20tones%2C%20confident%20calm%20mood%2C%20soft%20lighting%2C%20wide%20composition%2C%20high%20detail&width=1200&height=800&seq=actor-zhou-yaqin-wide&orientation=landscape",
    birthday: "1982-03-04",
    birthPlace: "北京",
    height: "170cm",
    bio: "周雅琴从艺二十余年，是观众熟悉的老戏骨。她台词功底扎实，情绪控制精准，擅长演绎复杂立体的成熟女性形象。无论正剧还是喜剧，她都能举重若轻，被称为“定海神针”式的演员。",
    works: ["kind-sister-in-law", "city-lights", "long-night-clear", "happy-family"],
    roles: [
      { dramaId: "kind-sister-in-law", role: "顾母", desc: "苏婉的婆婆，起初对儿媳心存怀疑，最终被其真心所感动。" },
      { dramaId: "city-lights", role: "陆总", desc: "创意公司的创始人，雷厉风行却重情义，是年轻人心中的引路人。" },
    ],
  },
  {
    id: "actor-gao-haisheng",
    name: "高海生",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20rugged%20middle%20aged%20Chinese%20actor%20with%20gray%20beard%20stubble%2C%20calm%20serious%20expression%2C%20dark%20jacket%2C%20warm%20neutral%20studio%20background%2C%20soft%20editorial%20lighting%2C%20professional%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-gao-haisheng-portrait&orientation=squarish",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20warm%20portrait%20of%20a%20rugged%20mature%20Chinese%20actor%20outdoors%20at%20golden%20hour%2C%20warm%20amber%20light%2C%20weathered%20thoughtful%20expression%2C%20wide%20composition%2C%20high%20detail&width=1200&height=800&seq=actor-gao-haisheng-wide&orientation=landscape",
    birthday: "1975-11-19",
    birthPlace: "陕西西安",
    height: "180cm",
    bio: "高海生是影坛公认的实力派，兼具演员与导演双重身份。他塑造的角色往往厚重而真实，充满生活质感。近年他执导并主演多部现实题材作品，获得业内广泛认可。",
    works: ["kind-sister-in-law", "mountain-echo", "silent-witness", "wild-trek", "chasing-light"],
    roles: [
      { dramaId: "kind-sister-in-law", role: "顾父", desc: "沉默寡言的家主，把对儿媳的感激藏在心里，用行动默默守护这个家。" },
      { dramaId: "mountain-echo", role: "陈守山", desc: "坚守乡土一辈子的老父亲，代表着那一代人最朴素的信念。" },
    ],
  },
  {
    id: "actor-su-xiaoyu",
    name: "苏小雨",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20bright%20cheerful%20young%20Chinese%20actress%20with%20long%20soft%20hair%2C%20warm%20friendly%20smile%2C%20light%20cream%20sweater%2C%20warm%20beige%20studio%20background%2C%20soft%20editorial%20lighting%2C%20professional%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-su-xiaoyu-portrait&orientation=squarish",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20warm%20portrait%20of%20a%20cheerful%20young%20Chinese%20actress%20in%20a%20sunlit%20cafe%2C%20warm%20cream%20and%20peach%20tones%2C%20joyful%20natural%20mood%2C%20soft%20lighting%2C%20wide%20composition%2C%20high%20detail&width=1200&height=800&seq=actor-su-xiaoyu-wide&orientation=landscape",
    birthday: "1996-08-15",
    birthPlace: "四川成都",
    height: "165cm",
    bio: "苏小雨以清新自然的演技和极具亲和力的形象受到年轻观众喜爱。她既能胜任青春爱情题材，也能在喜剧中展现出色的节奏感，被视为新生代中极具潜力的女演员。",
    works: ["kind-sister-in-law", "city-lights", "summer-letter", "happy-family", "voice-of-future"],
    roles: [
      { dramaId: "kind-sister-in-law", role: "顾念", desc: "顾家的小女儿，天真烂漫，是家里的开心果，也是最早接纳苏婉的人。" },
      { dramaId: "summer-letter", role: "夏栀", desc: "海边小镇长大的女孩，十年后收到一封迟到信件，重新面对青春往事。" },
    ],
  },
  {
    id: "actor-li-mubai",
    name: "李慕白",
    avatar:
      "https://readdy.ai/api/search-image?query=Portrait%20of%20a%20refined%20young%20Chinese%20actor%20with%20neat%20dark%20hair%2C%20gentle%20thoughtful%20expression%2C%20light%20gray%20knitwear%2C%20warm%20neutral%20studio%20background%2C%20soft%20editorial%20lighting%2C%20professional%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-li-mubai-portrait&orientation=squarish",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20warm%20portrait%20of%20a%20refined%20young%20Chinese%20actor%20in%20a%20moody%20warm%20interior%2C%20earth%20tones%2C%20contemplative%20expression%2C%20soft%20directional%20light%2C%20wide%20composition%2C%20high%20detail&width=1200&height=800&seq=actor-li-mubai-wide&orientation=landscape",
    birthday: "1994-01-30",
    birthPlace: "湖南长沙",
    height: "182cm",
    bio: "李慕白外形清俊，气质沉静，擅长演绎内敛深情、层次丰富的角色。他注重台词与微表情的细节处理，在年代戏与古装戏中均有亮眼表现，被观众称为“安静的潜力股”。",
    works: ["mountain-echo", "silent-witness", "summer-letter", "long-night-clear", "chasing-light", "wild-trek"],
    roles: [
      { dramaId: "long-night-clear", role: "裴清", desc: "位高权重的少年将军，与晴川在权谋漩涡中相知相惜。" },
      { dramaId: "chasing-light", role: "阿远", desc: "失去双腿却从未放弃的少年，用轮椅跑出了属于自己的人生赛道。" },
    ],
  },
];